import React, {useCallback, useContext, useEffect, useState} from "react";
import {AuthContext} from "../../../context/authContext";
import moment from "moment";
import Spreadsheet from "./spreadsheet/Spreadsheet";
import {BiPlus} from "react-icons/bi";
import CreateFolderModal from "../../../components/modals/CreateFolderModal";
import axios from "../../../utils/authAxios";

const columns = [
    {key: 'contractNumber', title: 'Contract No.'},
    {key: 'contractDate', title: 'Contract Date'},
    {key: 'account', title: 'Account'},
    {key: 'diff', title: 'Diff.'},
    {key: 'mt', title: 'MT'},
    {key: 'lots', title: 'Lot/s'},
    {key: 'shipment', title: 'Shipment'},
    {key: 'quality', title: 'Quality'},
    {key: 'gtc', title: 'GTC'},
    {key: 'placeDate', title: 'Place Date'},
    {key: 'fixedDate', title: 'Fixed Date'},
    {key: 'traddocs', title: '', width: 80}
]

const Contract = ({teamData}) => {
    const {userState} = useContext(AuthContext);
    const userInfo = userState.user;
    const currentMonth = moment().format("MMMM");
    const nextMonth = moment().add(1, "months").format("MMMM");

    const [isCreateFolderModalOpen, setCreateFolderModalOpen] = useState(false);

    const [folders, setFolders] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const fetchArchives = useCallback(async () => {
        setLoading(true);
        try {
            const response = await axios.get(`/v1/archives`, {
                params: {team_id: teamData?.team_id || null},
            });

            setFolders(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [teamData]);

    useEffect(() => {
        fetchArchives().then();
    }, [fetchArchives]);

    const DashboardHeader = () => (
        <div className="w-full bg-white border-b pr-4 p-2 flex justify-between items-center">
            <div className="flex space-x-4 items-center">
                {teamData ? (
                    <div
                        className="h-14 w-14 bg-gray-200 bg-opacity-40 rounded-lg flex-shrink-0 text-7xl font-medium text-white flex items-center justify-center overflow-hidden border">
                        <img className="w-full h-full" draggable={false} src={teamData.team_img} alt=""/>
                    </div>
                ) : (
                    <div
                        className="h-14 w-14 bg-white flex-shrink-0 bg-gradient-to-br from-fuchsia-400 to-fuchsia-300 text-4xl font-medium text-white flex items-center justify-center rounded-lg">
                        {userInfo.userName.slice(0, 1)}
                    </div>
                )}
                <div className="">
                    <p className="text-xl font-semibold">
                        {teamData ? `${teamData.team_name}'s Team` : `${userInfo.userName}'s Team`}
                    </p>
                    <div className="flex items-center space-x-2">
                        <p className="text-xs text-gray-400">
                            Current usage period ({currentMonth} 3 to {nextMonth} 2)
                        </p>
                        <div className="bg-gray-100 text-xs font-medium text-gray-500 px-2 py-1 rounded">
                            {teamData ? "Master Plan" : "Free Trial Plan"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const Card = ({title, child}) => (
        <div className="p-3 rounded-lg bg-white">
            <p className="mb-2 font-medium text-gray-500 text-xs">{title}</p>
            <div className="rounded-lg text-sm text-blue-600">{child}</div>
        </div>
    );

    return (
        <div className="w-full h-full overflow-auto bg-gray-100 text-gray-700 flex flex-col">
            <CreateFolderModal
                open={isCreateFolderModalOpen}
                setOpen={setCreateFolderModalOpen}
                fetchArchives={() => null}
                type="new"
            />
            <DashboardHeader/>
            <div className="w-full flex-1 bg-gray-100 rounded-lg p-3 flex flex-col">
                <div className="flex justify-between">
                    <Card title="Forward your email to:"
                          child={<div className="rounded-lg text-sm text-blue-600">auto@traddocs.com</div>}/>
                    <button
                        className="h-10 bg-blue-600 text-white text-sm flex items-center rounded-lg hover:bg-blue-500 transition py-2 px-4"
                        onClick={() => setCreateFolderModalOpen(true)}>
                        <BiPlus className="w-5 h-5"/>New Contract
                    </button>
                </div>
                <div className="flex-1">
                    <Spreadsheet extractedData={[{columns: columns, rows: [{}, {}, {}]}]}/>
                </div>
            </div>
        </div>
    );
};

export default Contract;
